import './OlimpicPlusGrid.css'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { formGrid } from './externalFunctions'

const OlimpicPlusGrid = ({
	sendMatchData,
	group,
	auth
}) => {
	const { t } = useTranslation()
	const tournamentState = useSelector(state => state.tournament.tournament)
	const [grid, setGrid] = useState([])
	const [columnOfResults, setColumnOfResults] = useState([])

	useEffect(() => {
		if (Object.keys(group).length !== 0) {
			const readyGrid = formGrid(group, tournamentState)

			if (readyGrid) {
				setGrid(readyGrid?.activeColumns)
				setColumnOfResults(readyGrid?.resultsColumn)
			}
		}
	}, [group, tournamentState])

	const setStyles = (columnIndex, matches, match, matchIndex) => {
		if (columnIndex < 1) {
			return
		} else if (match?.highlight && match?.borderTop && match?.borderBottom) {
			return {
				backgroundColor: '#EBF4FF',
				borderTop: '1px solid #367BCF',
				borderBottom: '1px solid #367BCF'
			}
		} else if (match?.highlight && match?.borderTop) {
			return {
				backgroundColor: '#EBF4FF',
				borderTop: '1px solid #367BCF'
			}
		} else if (match?.highlight && match?.borderBottom) {
			return {
				backgroundColor: '#EBF4FF',
				borderBottom: '1px solid #367BCF'
			}
		} else if (match?.highlight) {
			return {
				backgroundColor: '#EBF4FF',
			}
		} else if (!match?.highlight && matches[matchIndex + 1].highlight) {
			return {
				borderBottom: 'none'
			}
		}
	}

	const formMatch = (match) => {
		let updatedMatch

		if (tournamentState?.type === 'singles') {
			updatedMatch = {
				...match,
				side1: {
					namePlayer: match?.nodeOne?.name
				},
				side2: {
					namePlayer: match?.nodeTwo?.name
				},
				uid: match?.matchUid
			}
		} else {
			updatedMatch = {
				...match,
				side1: {
					namePlayer1: match?.nodeOne?.firstPlayerName,
					namePlayer2: match?.nodeOne?.secondPlayerName
				},
				side2: {
					namePlayer1: match?.nodeTwo?.firstPlayerName,
					namePlayer2: match?.nodeTwo?.secondPlayerName
				},
				uid: match?.matchUid
			}
		}
		return updatedMatch
	}

	const goToMatch = (match) => {
		// переделать таблицы для общего вида посылаемых данных в матч?
		if ((tournamentState?.type === 'singles' && (!match?.nodeOne?.playerUid || !match?.nodeTwo?.playerUid))
			|| !auth || (tournamentState?.type === 'doubles'
				&& (!match.nodeOne?.available || !match.nodeTwo?.available))) {
			return
		} else {
			const updatedMatch = formMatch(match)

			sessionStorage.setItem('activatedComponent', 'match')
			sessionStorage.setItem('match', JSON.stringify(updatedMatch))
			sendMatchData(updatedMatch)
		}
	}

	return (
		<div className="olympicplus-grid__container">
			<p className="olympicplus-grid__title">
				{t('Group')} {group?.name}
			</p>

			<div className="olympicplus-grid__columns">
				{
					grid?.map((column, columnIndex) =>
						<div className="olympicplus-grid__column" key={columnIndex}>
							<div className="olympicplus-grid__column-title">
								<span className="olympicplus-grid__column-title-round">
									{t(column?.roundName)}
								</span>
							</div>

							<div
								className={
									columnIndex === 0 ?
										'olympicplus-grid__column-container--first'
										:
										'olympicplus-grid__column-container'
								}
							>
								{
									column?.matches?.map((match, matchIndex) =>
										<div
											onClick={() => goToMatch(match)}
											className={
												match?.nodeOne?.type === 'incoming' ?
													'olympicplus-grid__cell--first'
													:
													'olympicplus-grid__cell'
											}
											key={matchIndex}
											style={setStyles(columnIndex, column?.matches, match, matchIndex)}
										>
											<p className="olympicplus-grid__cell-number">
												{
													match?.match ?
														match?.matchNumber
														:
														''
												}
											</p>

											<div
												className={match?.nodeOne?.type === 'incoming' ?
													'olympicplus-grid__cell-container--first'
													:
													'olympicplus-grid__cell-container'
												}
												style={{
													height:
														tournamentState?.type === 'singles' && !match?.nodeTwo
															? '4.5vh' : tournamentState?.type === 'singles'
																? '9vh' : match?.nodeTwo ? '13vh' : ''
												}}
											>
												{
													tournamentState?.type === 'singles' &&
													<div
														className="olympicplus-grid__cell-players"
													>
														<p className="olympicplus-grid__cell-name">
															{match?.nodeOne?.name}
														</p>

														{
															match?.nodeTwo &&
															<p className="olympicplus-grid__cell-name">
																{match?.nodeTwo?.name}
															</p>
														}
													</div>
												}

												{
													tournamentState?.type === 'doubles' &&
													<div
														className="olympicplus-grid__cell-doubles"
														style={{
															height: !match?.nodeTwo ?
																'6.5vh'
																:
																'13vh'
														}}
													>
														{
															!match?.nodeOne?.name && match?.nodeOne?.available ?
																<div className="olympicplus-grid__cell-doubles-item">
																	<p className="olympicplus-grid__cell-name--doubles">
																		{match?.nodeOne?.firstPlayerName}
																	</p>

																	<p className="olympicplus-grid__cell-name--doubles">
																		{match?.nodeOne?.secondPlayerName}
																	</p>
																</div>
																:
																match?.nodeOne?.name ?
																	<p className="olympicplus-grid__cell-noname">
																		{match?.nodeOne?.name}
																	</p>
																	:
																	<p className="olympicplus-grid__cell-noname">
																		---
																	</p>
														}

														{
															match?.nodeTwo && !match?.nodeTwo?.name &&
																match?.nodeTwo?.available ?
																<div className="olympicplus-grid__cell-doubles-item">
																	<p className="olympicplus-grid__cell-name--doubles">
																		{match?.nodeTwo?.firstPlayerName}
																	</p>

																	<p className="olympicplus-grid__cell-name--doubles">
																		{match?.nodeTwo?.secondPlayerName}
																	</p>
																</div>
																: match?.nodeTwo && match?.nodeTwo?.name ?
																	<p className="olympicplus-grid__cell-noname">
																		{match?.nodeTwo?.name}
																	</p>
																	: match?.nodeTwo ?
																		<p className="olympicplus-grid__cell-noname">
																			---
																		</p>
																		: ''
														}
													</div>
												}

												{
													match?.sets && match?.sets?.length > 0 &&
													<div className="olympicplus-grid__cell-result">
														{
															match?.sets?.map((s, setIndex) =>
																<div
																	className="olympicplus-grid__cell-scores"
																	key={setIndex}
																>
																	<p className="olympicplus-grid__cell-score">
																		{s?.score1}

																		<sup className="olympicplus-grid__cell-tiebreak">
																			{
																				s?.tie_break_score1 >= 0 ?
																					s?.tie_break_score1
																					:
																					''
																			}
																		</sup>
																	</p>

																	<p className="olympicplus-grid__cell-score">
																		{s?.score2}

																		<sup className="olympicplus-grid__cell-tiebreak">
																			{
																				s?.tie_break_score2 >= 0 ?
																					s?.tie_break_score2
																					:
																					''
																			}
																		</sup>
																	</p>
																</div>
															)
														}
													</div>
												}

												{
													match?.sets && match?.sets?.length < 1 &&
														match?.nodeTwo?.available && match?.nodeOne?.available ?
														<div className="olympicplus-grid__cell-result">
															<div className="olympicplus-grid__cell-scores">
																<p className="olympicplus-grid__cell-score">
																	0
																</p>

																<p className="olympicplus-grid__cell-score">
																	0
																</p>
															</div>
														</div>
														:
														''
												}
											</div>
										</div>
									)
								}
							</div>
						</div>
					)
				}

				<div className="olympicplus-grid__column">
					<p className="olympicplus-grid__column-title">
						{t('Result')}
					</p>

					<div className="olympicplus-grid__result">
						{
							columnOfResults?.map((cell, cellIndex) =>
								<div
									key={cellIndex}
									className="olympicplus-grid__result-container"
									style={{
										height: tournamentState?.type === 'singles' ? '4.5vh' : '6.5vh',
										borderBottom: columnOfResults.length < 2 ? '1px solid #CCC' : ''
									}}
								>
									<p className="olympicplus-grid__result-place">
										{
											cell?.name !== '---' ?
												cellIndex + 1
												:
												''
										}
									</p>

									{
										tournamentState?.type === 'singles' ?
											<p className="olympicplus-grid__result-name">
												{cell?.name}
											</p>
											:
											<div>
												{
													cell?.available ?
														<div className="olympicplus-grid__cell-doubles-item">
															<p className="olympicplus-grid__cell-name--doubles">
																{cell?.firstPlayerName}
															</p>

															<p className="olympicplus-grid__cell-name--doubles">
																{cell?.secondPlayerName}
															</p>
														</div>
														:
														<p className="olympicplus-grid__cell-noname">
															{cell?.name}
														</p>
												}
											</div>
									}
								</div>
							)
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default OlimpicPlusGrid